import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService, ON_AUTH_STATE_CHANGED } from './auth.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const firebaseAuth = inject(Auth);
  const onAuthStateChanged = inject(ON_AUTH_STATE_CHANGED);

  if (environment.skipFirebaseAuth) {
    return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
  }

  return new Promise<boolean | UrlTree>((resolve) => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
      unsubscribe();
      resolve(user ? true : router.createUrlTree(['/login']));
    });
  });
};

export const loginGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const firebaseAuth = inject(Auth);
  const onAuthStateChanged = inject(ON_AUTH_STATE_CHANGED);

  if (environment.skipFirebaseAuth) {
    return auth.isAuthenticated() ? router.createUrlTree(['/dashboard']) : true;
  }

  return new Promise<boolean | UrlTree>((resolve) => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
      unsubscribe();
      resolve(user ? router.createUrlTree(['/dashboard']) : true);
    });
  });
};
